var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height"},[(_vm.isProductAndCountrySet)?_vm._t("content",[_vm._v("\n    "+_vm._s(_vm.product)+"\n  ")]):_c('div',[_c('empty')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }